import type { SearchPagination, SearchResponse } from '@algolia/client-search';
import type { RefObject } from 'react';

import type { ApiJobId } from '#/api/types/ApiTypedId';
import type { ScrollAreaHandle } from '#/components/ScrollArea/ScrollArea';
import type { SearchAlgoliaHit } from '#/modules/search/algolia/types/SearchAlgoliaHit';
import { SearchLoadingSectionMockResults } from '#/modules/search/components/Loading/SearchLoadingSectionMockResults';
import type { SearchContextHeaderData } from '#/modules/search/containers/SearchContextHeader/SearchContextHeaderData';
import {
  type SearchSavedListingsStore,
  useSearchSavedListingsSyncAlgoliaHits,
} from '#/modules/search/zustand-stores/searchSavedListingsStore';

import { ViewJobPageSidebarPaginationHolder } from './ViewJobPageSidebarPagination.styled';
import { ViewJobPageSidebarPaginationHits } from './ViewJobPageSidebarPaginationHits';

type Props = {
  jobId: ApiJobId;
  results?: SearchResponse<SearchAlgoliaHit> & Required<SearchPagination>;
  searchContext: SearchContextHeaderData;
  searchSavedListingsStore: SearchSavedListingsStore;
  scrollingParentRef: RefObject<ScrollAreaHandle | null>;
};

export function ViewJobPageSidebarPagination({
  jobId,
  results,
  searchContext,
  scrollingParentRef,
  searchSavedListingsStore,
}: Props) {
  useSearchSavedListingsSyncAlgoliaHits({
    hits: results?.hits,
    searchSavedListingsStore,
  });

  return (
    <ViewJobPageSidebarPaginationHolder>
      {results ? (
        <ViewJobPageSidebarPaginationHits
          selectedJobId={jobId}
          selectedJobPage={results.page}
          queryID={results.queryID}
          selectedJobPageHits={results.hits}
          totalPages={results.nbPages}
          searchContext={searchContext}
          scrollingParentRef={scrollingParentRef}
          searchSavedListingsStore={searchSavedListingsStore}
        />
      ) : (
        <SearchLoadingSectionMockResults items={3} />
      )}
    </ViewJobPageSidebarPaginationHolder>
  );
}
